import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'common/components/modules/modal';
import Button from 'common/components/elements/buttons/primary';
import { Item } from '../choose-payment-type'
import IconLabel from 'common/components/elements/icon-label';

const itemsCard = {
   video_unlock: {
      icon: 'videos',
   },
   video_download: {
      icon: 'download',
   },
   photoset_unlock: {
      icon: 'photosets',
   },
   photoset_download: {
      icon: 'download',
   },
   tip: {
      icon: 'tip',
      title: 'Tip',
   },
   chat_text_message: {
      icon: 'chat',
      title: 'Chat text message',
   },
   chat_voice_message: {
      icon: 'chat',
      title: 'Chat voice message',
   },
   chat_photo_message: {
      icon: 'chat',
      title: 'Chat image message',
   },
   chat_video_unlock: {
      icon: 'chat-unlock',
      title: 'Chat video unlock',
   },
   chat_photo_unlock: {
      icon: 'chat-unlock',
      title: 'Chat photo unlock',
   },
   mass_message: {
      icon: 'chat-unlock',
      title: 'Chat unlock',
   },
   store: {
      icon: 'store',
   },
   wallet: {
      icon: 'wallet',
      title: 'Wallet top up',
   },
}

const WarningOfScore = ({
   isMobile,
   onModalClose,
   item,
   walletBalance,
   message,
   purchaseUsingWallet,
   fetchPaymentUsingWallet,
}) => {
   return (
      <Modal
         contentPosition={ !isMobile ? 'center' : 'bottom' }
         onClose={ onModalClose }
         contentWidth={ isMobile ? '100%' : '375px' }
         // animate={ isMobile ? animate : null }
         isCloseAction={ false }
      >

         <WarningOfScoreContent
            walletBalance={ walletBalance }
            message={ message }
            item={ item }
            onModalClose={ onModalClose }
            purchaseUsingWallet={ () => purchaseUsingWallet({ id: item.id, type: item.type }) }
            fetchPaymentUsingWallet={ fetchPaymentUsingWallet }
         />
      </Modal>
   );
};

const WarningOfScoreContent = ({
   walletBalance,
   message,
   item,
   onModalClose,
   purchaseUsingWallet,
   fetchPaymentUsingWallet,
}) => {
   const itemType = item.type;
   let itemIcon = null;
   if(!!itemType) itemIcon = itemsCard[itemType];
   const showWalletPayment = Boolean(
      !!walletBalance &&
      !item.type.includes('wallet') &&
      'store' !== item.type &&
      'total_amount_of_ccard_payments_in_30_days' === message.error_type &&
      walletBalance >= item.price
   )
   return (
      <>
         <div
            className='border-b border-divider dark:border-divider-dark px-4 py-3 flex items-center'>
            <div className='w-6 h-6 mr-4'>
               <Button
                  iconName='close'
                  fontIconColor='major'
                  darkIconcolor='major-dark'
                  classNames='h-full w-full'
                  backgroundColor='transparent'
                  waveColor='rgba(33, 33, 33, 0.8)'
                  padding='none'
                  onClick={ onModalClose }
               />
            </div>
            <span className='leading-tight text-major dark:text-major-dark'> Payment method </span>
         </div>
         <div className='flex flex-col p-5'>
            <div className='flex flex-col items-center'>
               {
                  itemIcon && itemIcon.icon && (
                     <IconLabel
                        isPrimary
                        name={ itemIcon.icon }
                        size='2xl'
                        className='w-11 h-11 mb-6'
                     />
                  )
               }
               <span className='text-2xl text-major dark:text-major-dark leading-7'>
                  {item.name || itemIcon?.title || ''}
               </span>
               <span className='leading-tight mt-2 text-secondary dark:text-secondary-dark '>
                  {item.price} USD
               </span>
            </div>
            <span className='text-sm text-secondary dark:text-secondary-dark mt-4'>
               {message.body}
               {
                  'total_amount_of_ccard_payments_in_30_days' === message.error_type && !!showWalletPayment && (
                     <>
                        <br />
                        <br />
                        You can, however purchase using your wallet.
                     </>
                  )
               }

            </span>
            {
               !!showWalletPayment && (
                  <div className='w-full mt-4'>
                     <Item
                        isChecked={ true }
                        setPaymentMethod={ () => {} }
                        balance={ walletBalance }
                        type='wallet'
                     />
                  </div>
               )
            }
            <div className='flex justify-between items-center cursor-pointer mt-4 h-7 mx-auto'>
               <Button
                  text='More info on payments limits'
                  textSize='base'
                  classNames='h-full w-full more-info-on-payments-limits intercom-more-info-on-payment-limits'
                  iconName='attention-outline'
                  iconPosition='left'
                  alignment='end'
                  backgroundColor='transparent'
                  primaryColor
                  fontIconSize='large'
                  textPosition='left'
                  onClick={ () => {} }
               />
            </div>
            {
               !!showWalletPayment && (
                  <div className='flex w-full h-12 mt-8'>
                     <Button
                        text='Buy with Wallet'
                        textSize='base'
                        classNames='h-full w-full'
                        primaryColor
                        onClick={ purchaseUsingWallet }
                        borderRadius='large'
                        isLoading={ fetchPaymentUsingWallet }
                     />
                  </div>

               )
            }
         </div>
      </>
   )
}


WarningOfScore.propTypes = {
   item: PropTypes.object,
   walletBalance: PropTypes.number,
   onModalClose: PropTypes.func,
   isMobile: PropTypes.bool,
   message: PropTypes.object,
   purchaseUsingWallet: PropTypes.func,
   fetchPaymentUsingWallet: PropTypes.bool,
};

WarningOfScoreContent.propTypes = {
   item: PropTypes.object,
   walletBalance: PropTypes.number,
   message: PropTypes.object,
   onModalClose: PropTypes.func,
   purchaseUsingWallet: PropTypes.func,
   fetchPaymentUsingWallet: PropTypes.bool,
};

WarningOfScore.defaultProps = {
}
export { WarningOfScoreContent }
export default React.memo(WarningOfScore);
